import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
  bgColor: "#262626",
  textColor: "#F2A341",
  borderColor: "#3552F2",
  subColor: "#95BF6B",
};
